<div class="formulario-aviso p-2 mb-5">
  <p class="pt-4">
    <span>Atendimento</span>
  </p>
  <p class="title-form-pages">Assistência Técnica</p>
  <p class="p-3">
    Caro cliente, você pode tirar suas dúvidas muito rapidamente acessando nossa
    central de Dúvidas Frequentes. <br />Caso tenha algum problema com algum de
    nossos produtos, contate o nosso SAC no número abaixo.
  </p>
</div>

<div class="container mt-3">
  <div class="row">
    <div class="col-md-6 pb-3">
      <a style="text-decoration: none" href="atendimento/duvidas-frequentes">
        <div class="card-form">
          <img
            class="card-img col-8"
            src="../../../../assets/icons/duvidas_icon.svg"
            alt=""
          />
          <div class="card-form-content-text col-8">
            <p>
              <span>Dúvidas Frequentes</span> <br />
              Para dúvidas de utilização ou funcionamento de produtos
            </p>
          </div>
          <img
            class="icon-area col-1"
            src="../../../../assets/icons/Icon.svg"
          />
        </div>
      </a>
    </div>
    <div class="col-md-6 pb-3">
      <a style="text-decoration: none" href="tel:+554733310800">
        <div class="card-form">
          <img
            class="card-img col-8"
            src="../../../../assets/icons/atendimento_icon2.svg"
            alt=""
          />
          <div class="card-form-content-text col-8">
            <p>
              <span>SAC (47) <span class="fone"> 3331.0800 </span></span> <br />
              Atendimento telefônico somente em horário comercial
            </p>
          </div>
          <img
            class="icon-area col-1"
            src="../../../../assets/icons/Icon.svg"
          />
        </div>
      </a>
    </div>
  </div>
</div>

<div class="container pt-4">
  <div class="description-text description-text__blue text-center pb-2 pb-md-4">
    Formulário
  </div>
  <form
    [formGroup]="formAssistenciaTecnica"
    (submit)="onSubmit('Assistência Técnica')"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <select
              class="form-select"
              formControlName="quemSou"
              [class.error]="formAssistenciaTecnica.controls['quemSou'].errors?.['required'] &&
            (formAssistenciaTecnica.controls['quemSou'].dirty || (formAssistenciaTecnica.controls['quemSou'].touched)|| submitted)"
            >
              <option
                disabled
                selected
                value=""
                [selected]="!formAssistenciaTecnica.controls['quemSou'].value"
              >
                Quem sou?
              </option>

              <option
                *ngFor="let option of optionsQuemSou"
                [value]="option.value"
              >
                {{ option.viewValue }}
              </option>
            </select>
            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['quemSou'].errors?.['required'] && (formAssistenciaTecnica.controls['quemSou'].dirty || (formAssistenciaTecnica.controls['quemSou'].touched)|| submitted)"
            >
              Selecione uma opção.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              formControlName="nome"
              type="text"
              name="nome"
              (change)="saverange($event, 'nome')"
              placeholder="Nome"
              [class.error]="
                formAssistenciaTecnica.controls['nome'].errors &&
                (formAssistenciaTecnica.controls['nome'].dirty ||
                  formAssistenciaTecnica.controls['nome'].touched ||
                  submitted)
              "
            />

            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['nome'].errors?.['required'] && (formAssistenciaTecnica.controls['nome'].dirty || (formAssistenciaTecnica.controls['nome'].touched) || submitted)"
            >
              Nome é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['nome'].errors?.['required'] && (formAssistenciaTecnica.controls['nome'].dirty || (formAssistenciaTecnica.controls['nome'].touched) || submitted) && formAssistenciaTecnica.controls['nome'].errors"
            >
              Nome inválido.
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              formControlName="email"
              type="text"
              placeholder="E-mail"
              (change)="saverange($event, 'email')"
              [class.error]="
                formAssistenciaTecnica.controls['email'].errors &&
                (formAssistenciaTecnica.controls['email'].dirty ||
                  formAssistenciaTecnica.controls['email'].touched ||
                  submitted)
              "
            />

            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['email'].errors?.['required'] && (formAssistenciaTecnica.controls['email'].dirty || (formAssistenciaTecnica.controls['email'].touched)|| submitted)"
            >
              E-mail é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['email'].errors?.['required'] && (formAssistenciaTecnica.controls['email'].dirty || (formAssistenciaTecnica.controls['email'].touched)|| submitted) && formAssistenciaTecnica.controls['email'].errors"
            >
              E-mail inválido.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              formControlName="telefone"
              type="text"
              mask="(00)0000-0000 || (00)00000-0000 "
              placeholder="Telefone"
              [class.error]="
                formAssistenciaTecnica.controls['telefone'].errors &&
                (formAssistenciaTecnica.controls['telefone'].dirty ||
                  formAssistenciaTecnica.controls['telefone'].touched ||
                  submitted)
              "
            />
            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['telefone'].errors?.['required'] && (formAssistenciaTecnica.controls['telefone'].dirty || (formAssistenciaTecnica.controls['telefone'].touched)|| submitted)"
            >
              Telefone é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['telefone'].errors?.['required'] && (formAssistenciaTecnica.controls['telefone'].dirty || (formAssistenciaTecnica.controls['telefone'].touched)|| submitted) && formAssistenciaTecnica.controls['telefone'].errors"
            >
              Telefone inválido.
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <select
              class="form-select"
              formControlName="estado"
              [class.error]="formAssistenciaTecnica.controls['estado'].errors?.['required'] && (formAssistenciaTecnica.controls['estado'].dirty || (formAssistenciaTecnica.controls['estado'].touched)|| submitted)"
            >
              <option
                value=""
                disabled
                [selected]="!formAssistenciaTecnica.controls['estado'].value"
              >
                Selecione um estado
              </option>
              <option *ngFor="let estado of listaEstados" [value]="estado.nome">
                {{ estado.nome }}
              </option>
            </select>
            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['estado'].errors?.['required'] && (formAssistenciaTecnica.controls['estado'].dirty || (formAssistenciaTecnica.controls['estado'].touched)|| submitted)"
            >
              Selecione um estado.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <select
              class="form-select"
              formControlName="cidade"
              [class.error]="formAssistenciaTecnica.controls['cidade'].errors?.['required'] && (formAssistenciaTecnica.controls['cidade'].dirty || (formAssistenciaTecnica.controls['cidade'].touched)|| submitted)"
            >
              <option
                value=""
                *ngIf="formAssistenciaTecnica.controls['estado'].errors"
              >
                Selecione um estado primeiro
              </option>
              <option
                value=""
                [selected]="!formAssistenciaTecnica.controls['cidade'].value"
                *ngIf="!formAssistenciaTecnica.controls['estado'].errors"
              >
                Selecione uma cidade
              </option>
              <option *ngFor="let cidade of listaCidades[0]" [value]="cidade">
                {{ cidade }}
              </option>
            </select>
            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['cidade'].errors?.['required'] && (formAssistenciaTecnica.controls['cidade'].dirty || (formAssistenciaTecnica.controls['cidade'].touched)|| submitted)"
            >
              Selecione a cidade.
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              type="text"
              formControlName="endereco"
              (change)="saverange($event, 'endereco')"
              placeholder="Endereço"
              [class.error]="
                formAssistenciaTecnica.controls['endereco'].errors &&
                (formAssistenciaTecnica.controls['endereco'].dirty ||
                  formAssistenciaTecnica.controls['endereco'].touched ||
                  submitted)
              "
            />

            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['endereco'].errors?.['required'] && (formAssistenciaTecnica.controls['endereco'].dirty || (formAssistenciaTecnica.controls['endereco'].touched)|| submitted)"
            >
              Endereço é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['endereco'].errors?.['required'] && (formAssistenciaTecnica.controls['endereco'].dirty || (formAssistenciaTecnica.controls['endereco'].touched)|| submitted) && formAssistenciaTecnica.controls['endereco'].errors"
            >
              Endereço inválido.
            </span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              formControlName="bairro"
              type="text"
              placeholder="Bairro"
              (change)="saverange($event, 'bairro')"
              [class.error]="
                formAssistenciaTecnica.controls['bairro'].errors &&
                (formAssistenciaTecnica.controls['bairro'].dirty ||
                  formAssistenciaTecnica.controls['bairro'].touched ||
                  submitted)
              "
            />

            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['bairro'].errors?.['required'] && (formAssistenciaTecnica.controls['bairro'].dirty || (formAssistenciaTecnica.controls['bairro'].touched)|| submitted)"
            >
              Bairro é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['bairro'].errors?.['required'] && (formAssistenciaTecnica.controls['bairro'].dirty || (formAssistenciaTecnica.controls['bairro'].touched)|| submitted) && formAssistenciaTecnica.controls['bairro'].errors"
            >
              Bairro inválido.
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              formControlName="cep"
              type="text"
              mask="00000-000"
              placeholder="CEP"
              [class.error]="
                formAssistenciaTecnica.controls['cep'].errors &&
                (formAssistenciaTecnica.controls['cep'].dirty ||
                  formAssistenciaTecnica.controls['cep'].touched ||
                  submitted)
              "
            />
            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['cep'].errors?.['required'] && (formAssistenciaTecnica.controls['cep'].dirty || (formAssistenciaTecnica.controls['cep'].touched)|| submitted)"
            >
              CEP é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['cep'].errors?.['required'] && (formAssistenciaTecnica.controls['cep'].dirty || (formAssistenciaTecnica.controls['cep'].touched)|| submitted) && formAssistenciaTecnica.controls['cep'].errors"
            >
              CEP inválido.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              class="form-control"
              formControlName="produto"
              type="text"
              placeholder="Qual produto?"
              (change)="saverange($event, 'produto')"
              [class.error]="
                formAssistenciaTecnica.controls['produto'].errors &&
                (formAssistenciaTecnica.controls['produto'].dirty ||
                  formAssistenciaTecnica.controls['produto'].touched ||
                  submitted)
              "
            />

            <span
              class="text-danger"
              *ngIf="formAssistenciaTecnica.controls['produto'].errors?.['required'] && (formAssistenciaTecnica.controls['produto'].dirty || (formAssistenciaTecnica.controls['produto'].touched)|| submitted)"
            >
              Produto é necessário.
            </span>
            <span
              class="text-danger"
              *ngIf="!formAssistenciaTecnica.controls['produto'].errors?.['required'] && (formAssistenciaTecnica.controls['produto'].dirty || (formAssistenciaTecnica.controls['produto'].touched)|| submitted) && formAssistenciaTecnica.controls['produto'].errors"
            >
              Produto inválido.
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <textarea
            class="form-control"
            id="mensagem"
            (input)="contarCaracteres($event)"
            formControlName="mensagem"
            rows="12"
            style="resize: none"
            placeholder="Qual seu problema?"
            (change)="saverange($event, 'mensagem')"
            [class.error]="
              formAssistenciaTecnica.controls['mensagem'].errors &&
              (formAssistenciaTecnica.controls['mensagem'].dirty ||
                formAssistenciaTecnica.controls['mensagem'].touched ||
                submitted)
            "
          ></textarea>

          <span
            class="text-danger"
            *ngIf="formAssistenciaTecnica.controls['mensagem'].errors?.['required'] && (formAssistenciaTecnica.controls['mensagem'].dirty || (formAssistenciaTecnica.controls['mensagem'].touched)|| submitted)"
          >
            Mensagem é necessária.
          </span>
          <span
            class="text-danger"
            *ngIf="!formAssistenciaTecnica.controls['mensagem'].errors?.['required'] && (formAssistenciaTecnica.controls['mensagem'].dirty || (formAssistenciaTecnica.controls['mensagem'].touched)|| submitted) && formAssistenciaTecnica.controls['mensagem'].errors"
          >
            Mensagem inválida. {{quantidadeCaracteres}} caractere(s) restante(s).
          </span>

        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-7">
          <div class="mb-3">
            <p class="font-gray-small min-area-form">
              Opção de envio de imagem ou arquivo <br />(JPG, PNG, PDF, DOC e
              DOCX)
            </p>
            <button
              type="button"
              (click)="anexarArquivo.click(); $event.preventDefault()"
              class="btn-ver-mais w-100 mb-2"
            >
              ANEXAR ARQUIVO
            </button>
            <input
              class="d-none"
              id="anexarArquivo"
              type="file"
              #anexarArquivo
              (change)="onFileSelect($event)"
              accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
            />
            <div *ngIf="fileTemp">Arquivo selecionado: {{ fileTemp.name }}</div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="mb-2 mt-2 min-area-form">
            <div class="form-check form-check-inline mb-3">
              <input
                (change)="aceitaReceberEmail($event)"
                class="form-check-input"
                type="checkbox"
                id="check"
              />
              <label class="form-check-label font-gray-small" for="check"
                >Desejo receber novidades e informações da Blukit em meu
                e-mail</label
              >
            </div>

          </div>


          <button [disabled]="submitted" class="btn-submit-form mb-2 mt-3" type="submit">
            Enviar
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
